import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
import {Link} from "react-router-dom";

function Block23() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content" style={{background: "#F5F9FE"}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center">
                        <div className="image-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/bureau3.webp" alt="bureau3" className="homepage"/>
                            </figure>
                        </div>

                        <div className="content-column col-xl-6 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Prolongez la sensibilisation avec <span>l’Académie de l’Inclusion</span></h2>
                                </div>
                                <div className="text">
                                    <b>Pour prolonger l’impact des webinaires, vos collaborateurs peuvent accéder à
                                        l’Académie de l’Inclusion,</b> un parcours en ligne composé de 5 modules courts et pédagogiques.
                                    <br/>
                                    Accessible directement en ligne, ce format permet d’ancrer les messages
                                    clés et de renforcer la dynamique de sensibilisation engagée lors du webinaire.
                                    <br/>
                                    <b>Le parcours comprend :</b>
                                    <ul className="list-style-two homepage">
                                        <li>5 modules courts et interactifs (environ 10 minutes chacun)</li>
                                        <li>Une approche pédagogique, simple et accessible à tous</li>
                                        <li>Des contenus conçus pour faire évoluer les représentations et les pratiques</li>
                                    </ul>
                                </div>

                                {/*<motion.button
                                        className="theme-btn btn-style-one small"
                                        initial={{opacity: 0, y: 0}}
                                        animate={{opacity: 1, y: 20}}
                                        transition={{delay: 1.0, duration: 1.5}}
                                        data-cal-namespace="ligne-inclusion"
                                        data-cal-link="team/talents-handicap/ligne-inclusion"
                                        data-cal-config='{"layout":"month_view"}'
                                >Réserver un créneau
                                </motion.button>


                                <ContactModal textButton="Découvrir l’Académie de l’Inclusion" showText={false} small="small"
                                              linkPageContact={false} iframe={false} couleur={false} formModal={true}/>*/}
                                <Link to="https://formation.talents-handicap.com/solutions-sensibilisation"
                                      rel="noopener noreferrer"
                                      target="_blank"
                                      className="theme-btn homepage btn-style-one small mt-3">
                                    Découvrir l’Académie de l’Inclusion</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block23;
